import { render, staticRenderFns } from "./Unbindofficialaccountdia.vue?vue&type=template&id=1d958d0c&scoped=true"
import script from "./Unbindofficialaccountdia.vue?vue&type=script&lang=js"
export * from "./Unbindofficialaccountdia.vue?vue&type=script&lang=js"
import style0 from "./Unbindofficialaccountdia.vue?vue&type=style&index=0&id=1d958d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d958d0c",
  null
  
)

export default component.exports